import { buildBuiltinScheme, buildSection } from './builder'

/**
 * 室内设计 · 写实风格 —— 预填常用 Tag 的预设方案。
 */
export const interiorScheme = buildBuiltinScheme(
  {
    id: 'builtin-interior',
    name: '室内设计 · 写实',
  },
  [
    buildSection('风格基调', 0, ['photorealistic', 'modern interior']),
    buildSection('空间类型 + 场景', 1, ['living room', 'afternoon']),
    buildSection('关键物体', 2, ['fabric sofa', 'wooden coffee table', 'floor lamp']),
    buildSection('关键细节', 3, ['indoor plants', 'woven rug', 'abstract wall art']),
    buildSection('材质描述', 4, ['matte oak', 'linen fabric', 'brushed brass']),
    buildSection('颜色方案', 5, ['warm beige', 'off-white', 'muted terracotta accents']),
    buildSection('光线描述', 6, ['soft natural daylight', 'warm golden hour glow']),
    buildSection('氛围描述', 7, ['cozy', 'serene', 'inviting']),
    buildSection('镜头语言', 8, ['wide angle', '35mm', 'eye level']),
    buildSection('质量描述', 9, ['ultra detailed', '8k', 'architectural photography']),
  ],
  {
    ar: '16:9',
    v: '6.1',
    style: 'raw',
    q: 2,
    s: 250,
  },
)
